import React, { useState, useEffect } from 'react';
import _fetch from '../Config/api';
import { base_url } from '../Config/config';
import toast from 'react-hot-toast';
import { ColorRing } from 'react-loader-spinner';
import logo from '../assets/img/notmacth.png'
import dateFormat from "dateformat";
import { Pagination } from "antd";
const Ticket = () => {

  const [api, setApi] = useState('');
  const [data, setData] = useState()
  const [secret, setSecret] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSer, setpageSer] = useState(0);

  const handleticket = async () => {
    try {
      const send = {

        subject: api,
        message: secret

      }
      console.log('send', send);

      let response = await _fetch(`${base_url}api/user/addTicket`, 'post', send, {});

      if (response.success === true) {
        toast.dismiss()
        toast.success(response?.message)
        setApi('')
        setSecret('')
        handletiket()
      } else {
        toast.dismiss()
        toast.error(response.message);
        setApi('')
        setSecret('')

      }
    } catch (error) {
      console.log("Error details", error);
    }
  }


  const handletiket = async (page = 1, pageSize = 10) => {
    try {
      const skip = (page - 1) * pageSize;
      setpageSer(skip);
      const requestData = {
        limit: pageSize,
        skip: skip,


      };

      let response = await _fetch(`${base_url}api/user/getTicket`, 'post', requestData);
      console.log('response ', response)
      if (response.success === true) {
        setData(response);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error details", error);
    }
  }

  useEffect(() => {
    handletiket(currentPage, 10);
  }, [currentPage]);
  const handlePaginationChange = (pageOne) => {
    setCurrentPage(pageOne);

  };


  const records = () => {
    if (data && data?.data && data?.data?.length > 0) {
      return data?.data?.map((row, i) => {
        const serialNumber = pageSer + i + 1;
        return (
          <>
            <div className="container p-1">
              <div className="card p-1">

                <div className="card-body">
                  <div className="row openPositionsDiv">
                    <div className="col-6">
                      <dl className="row mb-0 positionRow">
                        <dt className="col-sm-6">Subject:</dt>
                        <dd className="col-sm-6"><small>{row?.subject}</small></dd>
                        <dt className="col-sm-6">Message:</dt>
                        <dd className="col-sm-6">{row?.message}</dd>
                        {/* <dt className="col-sm-6">Created At:</dt>
                        <dd className="col-sm-6">{dateFormat(row?.createdAt, "yyyy-mm-dd, hh:mm:ss TT")}</dd>
                        */}
                      </dl>

                    </div>
                    <div className="col-6">
                      <dl className="row mb-0 positionRow">
                        <dt className="col-sm-6">Status</dt>
                        <dd className="col-sm-6">{row?.status}</dd>
                        <dt className="col-sm-6">Remarks :</dt>
                        <dd className="col-sm-6">{row?.remarks}</dd>
                        {/* <dt className="col-sm-6">Updated At:</dt>
                        <dd className="col-sm-6">{dateFormat(row?.updatedAt, "yyyy-mm-dd, hh:mm:ss TT")}</dd> */}
                      </dl>
                    </div>

                  </div>
                </div>
              </div>
            </div>



          </>

        );
      });
    } else {
      return (
        <tr>
          <td colSpan="13" className='text-center text-light m-auto d-block'>Data Not Found</td>
        </tr>
      );
    }
  };
  return (



    <>
      <div className="row justify-content-center p-3">
        <div className="mt-5 w-full message-11">
          <div className="bind_details mt-2">
            <div className="rounded  p-2">

              <h1 className='text-center ' style={{ marginTop: '10px' }}></h1>
              <h3 class="scan text-center">Ticket</h3>
            </div>
            <div className="rounded  p-2 mt-3">
              <div className="mb-2 row">
                <div className="col-sm-4 image-ticket">
                  <img className="welcome-1" src={logo} alt="" />
                </div>
                <div className="col-sm-8">
                  <label for="exampleInputEmail1" class="form-label user-text">Topic</label>
                  {/* <input
                    type="text"
                    className="form-control input user-text"
                    placeholder='Topic'
                    value={api}
                    onChange={(e) => setApi(e.target.value)}
                  /> */}
                  <select

                    className="form-control input form-select user-text"
                    aria-label="Default select example"
                    value={api}
                    onChange={(e) => setApi(e.target.value)}
                  >
                    <option value="">Select your Topic</option>

                    <option value="Why is the system rejecting certain withdrawal addresses?">Why is the system rejecting certain withdrawal addresses? </option>
                    <option value="Are there any issues with deposit confirmations or minimum confirmations required?">Are there any issues with deposit confirmations or minimum confirmations required?</option>
                    <option value="How can we optimize internal transfers for faster processing?">How can we optimize internal transfers for faster processing?</option>
                    <option value="Is the trade fee calculation accurate across all trading pairs?">Is the trade fee calculation accurate across all trading pairs? </option>
                    <option value="Other">Other</option>
                  </select>
                  <label for="exampleInputEmail1" class="form-label user-text">message</label>
                  <input
                    type="message"
                    className="form-control input user-text"
                    id="inputPassword"
                    placeholder='message'
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                  />
                  <button class="btn btn-danger m-auto d-block mt-3 " onClick={handleticket} type="button">Send</button>

                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="section2">

        <div className="table-sec">
          <div className="transactions">
            <div className="container mt-2">
              <div className="card start-date">
                <div className='row'>






                </div>
              </div>
            </div>

            {records()}

            <div className="pagination">
              <Pagination
                style={{ cursor: "pointer" }}
                className="mx-auto"
                current={currentPage || 1}
                total={data?.count || 0}
                pageSize={10}
                onChange={handlePaginationChange}
                showSizeChanger={false}
                showQuickJumper={false}
              />

            </div>
          </div>

        </div>
      </div>

    </>

  )
}

export default Ticket
